import { render, staticRenderFns } from "./dzs-tabel-sider.vue?vue&type=template&id=14b95c32&scoped=true"
import script from "./dzs-tabel-sider.vue?vue&type=script&lang=js"
export * from "./dzs-tabel-sider.vue?vue&type=script&lang=js"
import style0 from "./dzs-tabel-sider.vue?vue&type=style&index=0&id=14b95c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b95c32",
  null
  
)

export default component.exports